import { UrunAktarModalPage } from './../../MalKayit/urun-aktar-modal/urun-aktar-modal';
import { BarcodeScannerProvider } from './../../../providers/barcode-scanner-provider';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { MalgiriseklePage } from './../../MalKayit/malgirisekle/malgirisekle';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the MalkayitListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-malkayit-liste',
  templateUrl: 'malkayit-liste.html',
})
export class MalkayitListePage {
  @ViewChild('inputInventarioCB') CBProductoInventario;
  aranan = "";
  urunListesi: any = { Definition_: "", FaturaIDBarkod: "" };
  GelenListe = [];
  gidenid: any;
  depoListesi = [];
  depolar: any = [];
  timer: any;
  kalanmiktar: number = 0;
  stokhareket: any = {};
  Hareket: any = { ID: -1, StokHareketID: "", Miktar: "", StokID: "", DepoID: "", IslemiYapanKullaniciID: "", IslemTuru: "" };

  constructor(public navCtrl: NavController,
    private barcodeScanner: BarcodeScannerProvider,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MalkayitListePage');
    this.depogetir();
    this.yenile();
  }
  ionViewDidEnter() {
    this.focusInput(this.CBProductoInventario);
    //this.yenile();
  }

  yenile() {
    console.log("qq", this.urunListesi.FaturaIDBarkod)
    var formData = new FormData();
    formData.append("aranan_json", this.urunListesi.FaturaIDBarkod);
    this.bllOrtak.islem(formData, "MalHareketGetir", "", false).then(a => {
      var sonuc = <any>a;
      this.GelenListe = sonuc.SonucObject;
      if (this.GelenListe == null) {

        this.aranan = "";
      }
      else {
        this.urunListesi = this.GelenListe;
        this.aranan = "";
      }
    })
  }
  yeni(gidenid) {
    this.gidenid = this.urunListesi.ID;
    let modal = this.modalCtrl.create(MalgiriseklePage, { vwKayit: this.gidenid }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  focusInput(input) {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(() => {
      input.setFocus();
    }, 500);
  }

  UrunAra() {


    var formData = new FormData();
    formData.append("aranan_json", this.aranan);
    this.bllOrtak.islem(formData, "MalHareketGetir", "", false).then(a => {
      var sonuc = <any>a;
      this.GelenListe = sonuc.SonucObject;

      if (this.GelenListe == null) {


        //this.ionViewDidEnter();
        this.aranan = "";
      }
      else {
        this.urunListesi = this.GelenListe;
        this.kalanmiktar = this.urunListesi.KalanMiktar;

        this.aranan = "";


      }


    }).catch(x => {

    })
  }
  urunler(e) {
    if (e.keyCode == 13) {
      this.UrunAra();
    }
  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.UrunAra();
    })
  }
  barkodara() {
    this.barcodeScanner.barkodOku().then(barcodeData => {
      console.log('Barcode data', barcodeData);
    }).catch(err => {
      console.log('Error', err);
    });
  }
  depogetir() {
    var formData = new FormData();
    formData.append("aranan_json", this.aranan);
    this.bllOrtak.islem(formData, "DepoListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.depoListesi = sonuc.SonucObject;
      console.log("depolar", this.depoListesi)

    }).catch(x => {

    })


  }
  depoclick(depo, urunListesi) {
    let modal = this.modalCtrl.create(UrunAktarModalPage, { vwKayit: depo, vwHareket: urunListesi }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  aktarimmodal(depo) {
    this.kalanmiktar=this.urunListesi.KalanMiktar;
    console.log("kalanmiktar", this.kalanmiktar)
    this.ortak.alertAktarimPenceresi().then(a => {
      var sonuc = <any>a;
      var values = sonuc.values;
      var Miktar = values.Miktar;
      var formData = new FormData();
      this.Hareket.DepoID = depo.ID;
      this.Hareket.Miktar = Miktar;
      this.Hareket.StokHareketID = this.urunListesi.ID;
      this.Hareket.StokID = this.urunListesi.StokKartID;
    
      if (this.kalanmiktar < Miktar) {
        this.ortak.showBasicAlert("Uyarı", "Aktarmak istediğiniz palsan miktarı mevcut miktardan büyük olamaz");

      }
      else if (this.kalanmiktar > Miktar||this.kalanmiktar==Miktar) {

        formData.append("Aktarilan_json", JSON.stringify(this.Hareket));
        this.bllOrtak.islem(formData, "DepoyaAktar", "", true).then(a => {
          var sonuc = <any>a;
          if (sonuc.Sonuc == 1) {
            this.aranan = this.urunListesi.FaturaID;
            this.UrunAra();
          }
          else if (sonuc.Sonuc != 1) {

          }
        })
      }
    }
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/MalKayit/malkayit-liste/malkayit-liste.ts